export default {
  FEEDS: "फीड्स",
  FEED: "फीड",
};
